import { NumberFormat } from '../presentation-values.mjs';
import { assertDeclaredNumberFormat } from '../models/presentation.mjs';

// Exact admitted retained spellings, agreed with EXP. No parsing of Office patterns.
const LEGACY = Object.freeze({
  0: { style: 'decimal', digits: 0 },
  '0.00': { style: 'decimal', digits: 2 },
  '0%': { style: 'percent', digits: 0 },
  '0.00%': { style: 'percent', digits: 2 },
});

export function legacyNumberFormat(value, metadata, locale) {
  const known = Object.hasOwn(LEGACY, value) ? LEGACY[value] : null;
  if (!known || !locale || !metadata) return null;
  const format = NumberFormat.safeParse({
    locale,
    style: known.style,
    minimumFractionDigits: known.digits,
    maximumFractionDigits: known.digits,
    useGrouping: false,
    nullStyle: 'blank',
    scale: known.style === 'percent' ? 'fraction-to-percent' : 'identity',
  });
  if (!format.success) return null;
  try {
    return assertDeclaredNumberFormat(format.data, metadata);
  } catch {
    return null;
  }
}
